document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('.tww-category-wrapper');
  const leftBtn = document.querySelector('.tww-scroll-btn.left');
  const rightBtn = document.querySelector('.tww-scroll-btn.right');

  if (!wrapper || !leftBtn || !rightBtn) return;

  const scrollAmount = 240; // pixels to scroll per click

  rightBtn.addEventListener('click', function () {
    wrapper.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  });

  leftBtn.addEventListener('click', function () {
    wrapper.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
  });
});
document.addEventListener('DOMContentLoaded', function () {
  const items = document.querySelectorAll('.tww-category-item');

  items.forEach(function (item) {
    const dropdown = item.querySelector('.tww-dropdown');
    if (!dropdown) return;

    item.addEventListener('mouseenter', function () {
      const rect = item.getBoundingClientRect();
      dropdown.style.top = rect.bottom + 'px';
      dropdown.style.left = rect.left + 'px';
      dropdown.classList.add('tww-dropdown-visible');
    });

    item.addEventListener('mouseleave', function () {
      dropdown.classList.remove('tww-dropdown-visible');
    });
  });
});